export default {
  HOME: {
    GET_CONFIGS: 'get-configs',
    GET_HOME_DATA: 'get-home-data-v5',
    GET_BANK_LIST: 'get-bank-list',
    GET_IAP_LIST: 'get-iap-list',
    GET_IAP_LIST_V2: 'v2/get-iap-list'
  },
  AUTHENTICATE: {
    LOGIN: 'v2/authenticate/login',
    REFRESH: 'v2/authenticate/refresh'
  },
  USER: {
    // LOGIN: 'user/login',
    // SOCIAL_LOGIN: 'user/social-login',
    // DEVICE_LOGIN: 'user/device-login',
    // REFRESH: 'user/refresh',
    REGISTER: 'user/register',
    UPDATE: 'user/update',
    DELETE: 'user/delete',
    SUBMIT_CODE: 'user/submit-code',
    REQUEST_EMAIL_CODE: 'user/request-email-code',
    CHANGE_PASSWORD: 'user/change-pass',
    UPDATE_DEVICE: 'user/update-device',
    GET_MY_PURCHASE: 'user/get-my-purchase',
    GET_BANK_INFO: 'user/get-bank-info',
    UPDATE_BANK_INFO: 'user/update-bank-info',
    REMOVE_BANK_QR: 'user/remove-bank-qr',
    UPDATE_OFFLINE_ACTIVITY: 'user/update-offline-activity',
    UPDATE_USAGE_TIME: 'user/update-usage-time',
    UPDATE_WEBSITE_SETTING: 'user/update-website-settings',
    UPDATE_EXCEPTION: 'user/update-exception',
    GET_SHOP_SETTING: 'user/get-shop-settings',
    UPDATE_WEBSITE_DOMAIN: 'user/update-website-domain'
  },
  ORDER: {
    ADD: 'v11/order/add',
    UPDATE: 'v11/order/update',
    GET_DETAIL: 'v10/order/get-detail',
    DELETE: 'v3/order/delete',
    GET: 'v8/order/get',
    GET_STATISTIAL: 'order/get-statistial',
    GET_SALES_STATISTIAL: 'order/get-sales-statistial',
    GET_STATISTIAL_ALL_TYPE: 'order/get-statistial-all-type',
    GET_ALL: 'order/get-all',
    GET_QRCODE: 'order/get-qrcode',
    GET_QRCODE_V3: 'v3/order/get-qrcode',
    ADD_POS: 'order/add-pos-device',
    GET_POS: 'order/get-all-pos-device',
    GET_ORDER: 'staff/get-orders',
    CHANGE_ORDER_SLOT: 'staff/change-order-slot',
    GET_EXTRA_FEES: 'order/get-extra-fees',
    UPDATE_EXTRA_FEE: 'order/update-extra-fee',
    ADD_EXTRA_FEE: 'order/add-extra-fee',
    ADD_TEMPLATE: 'order/add-template',
    DELETE_TEMPLATE: 'order/delete-template',
    GET_TEMPLATES: 'order/get-templates',
    GET_TEMPLATE_DETAIL: 'order/get-template-detail',
    UPDATE_EINVOICE: 'v5/order/update-einvoice'
  },
  ORDER_SHIPPING: {
    CREATE: 'order-shipping/create',
    ESTIMATE_FEE: 'order-shipping/estimate-fee',
    UPDATE_STATUS: 'order-shipping/update-status',
    UPDATE_INFO: 'order-shipping/update-info',
    CANCEL: 'order-shipping/cancel',
    GET_DETAIL: 'order-shipping/get-detail',
    GET_BY_ORDER_ID: 'order-shipping/get-by-order-id',
    GET_LOGS: 'order-shipping/get-logs',
    GET_PROVIDERS: 'order-shipping/get-providers',
    GHN_PROVINCES: 'order-shipping/ghn/provinces',
    GHN_DISTRICTS: 'order-shipping/ghn/districts',
    GHN_WARDS: 'order-shipping/ghn/wards'
  },
  SHIPPING_PROVIDER: {
    SAVE_CONFIG: 'shipping-provider/save-config',
    GET_CONFIGS: 'shipping-provider/get-configs'
  },
  PRODUCT: {
    ADD: 'v4/product/add',
    GET: 'product/get',
    GET_V4: 'v4/product/get',
    GET_EXTRAS: 'product/get-extras',
    GET_V3: 'v3/product/get',
    GET_LIST: 'product/get-list',
    GET_LIST_V3: 'v3/product/get-list',
    GET_LIST_V4: 'v4/product/get-list',
    EXCEL_IMPORT: 'product/excel-import',
    UPDATE: 'v4/product/update',
    MULTI_DELETE: 'product/multi-delete',
    UPDATE_STATUS: 'product/update-status',
    DELETE: 'product/delete',
    GET_DETAIL: 'v4/product/get-detail',
    GET_SYNC_AMOUNT: 'product/get-sync-amount',
    GET_HISTORY: 'v4/product/get-history',
    GET_SOLD_HISTORY: 'v4/product/get-sold-history',
    GET_BY_COMPOSITION: 'product/get-by-composition',
    ADD_UNIT_CONVERT: 'product/add-unit-convert',
    UPDATE_UNIT_CONVERT: 'product/update-unit-convert',
    DELETE_UNIT_CONVERT: 'product/delete-unit-convert',
    DELETE_IMAGE: 'product/remove-image',
    GET_COMPONENT_DATA: 'product/get-component-data',
    GET_TOPPINGS: 'product/get-toppings'
  },
  CATEGORY: {
    ADD: 'category/add',
    GET: 'category/get',
    UPDATE: 'category/update',
    DELETE: 'category/delete',
    GET_DETAIL: 'category/get-detail',
    ADD_PRODUCTS: 'category/add-products'
  },
  CUSTOMER_GROUP: {
    ADD: 'customer-group/add',
    GET: 'customer-group/get',
    UPDATE: 'customer-group/update',
    DELETE: 'customer-group/delete',
    GET_DETAIL: 'customer-group/get-detail',
    ADD_CUSTOMERS: 'customer-group/add-customers',
    DELETE_CUSTOMERS: 'customer-group/delete-customers'
  },
  UNIT: {
    ADD: 'unit/add',
    GET: 'unit/get',
    UPDATE: 'unit/update',
    DELETE: 'unit/delete',
    GET_DETAIL: 'unit/get-detail'
  },
  COMPOSITION: {
    ADD: 'composition/add',
    GET: 'composition/get',
    UPDATE: 'composition/update',
    DELETE: 'composition/delete'
  },
  CUSTOMER: {
    ADD: 'customer/add',
    GET_LIST: 'customer/get-list',
    GET: 'customer/get',
    UPDATE: 'customer/update',
    DELETE: 'customer/delete',
    GET_DETAIL: 'v2/customer/get-detail',
    GET_ORDERS: 'v2/customer/get-orders',
    GET_LAST_PRICES: 'v2/customer/get-last-prices',
    GET_ORDER_DETAIL: 'customer/get-order-detail',
    GET_POINTS: 'customer/get-points',
    UPADTE_POINTS: 'customer/update-points',
    RESET_POINTS: 'customer/reset-points',
    GET_POINT_STAT: 'customer/get-point-stat',
    GET_BY_PHONE: 'customer/get-by-phone',
    GET_DEBTS: 'customer/get-debts'
  },
  BRANCH: {
    ADD: 'branch/add',
    UPDATE: 'branch/update',
    DELETE: 'branch/delete',
    GET: 'branch/get'
  },
  STAFF: {
    ADD: 'staff/add',
    UPDATE: 'staff/update',
    DELETE: 'staff/delete',
    GET: 'staff/get',
    GET_ORDERS: 'staff/get-orders'
  },
  FINANCIAL: {
    GET: 'v2/financial/get',
    GET_STAT: 'financial/get-stat',
    GET_DETAIL: 'financial/get-detail',
    ADD: 'financial/add',
    UPDATE: 'financial/update',
    DELETE: 'financial/delete',
    GET_TYPE: 'financial/get-type',
    ADD_TYPE: 'financial/add-type',
    DELETE_TYPE: 'financial/delete-type'
  },
  IAP: {
    VERIFY: 'v2/iap/verify',
    VERIFY_STAFF: 'iap/verify-staff',
    VERIFY_WAREHOUSE: 'iap/verify-warehouse',
    TRIAL_ACTIVE: 'iap/trial-active',
    GET_SUBS_INFO: 'iap/get-subs-info',
    GET_BANK_QR: 'iap/bank-qr'
  },
  SHIFT: {
    GET_DETAIL: 'shift/get-detail',
    END: 'shift/end',
    OPEN_V2: 'v2/shift/open',
    CURRENT_V2: 'v2/shift/current',
    GET_ORDERS_V2: 'v2/shift/get-orders',
    CLOSE_V2: 'v2/shift/close',
    DETAIL_V2: 'v2/shift/get-detail',
    LIST_V2: 'v2/shift/get-list'
  },
  SETTINGS: {
    UPDATE: 'settings/update'
  },
  WAREHOUSE: {
    ADD: 'warehouse/add',
    DELETE: 'warehouse/delete',
    UPDATE: 'warehouse/update',
    GET_LIST: 'warehouse/get',
    GET_DETAIL: 'warehouse/get-detail',
    CHECK: 'warehouse/check',
    GET_CHECK: 'warehouse/get-check',
    DELETE_CHECK: 'warehouse/delete-check',
    GET_LIST_CHECK: 'warehouse/get-list-check',
    TRANSFER: 'warehouse/transfer',
    GET_TRANSFER: 'warehouse/get-transfer',
    DELETE_TRANSFER: 'warehouse/delete-transfer',
    GET_LIST_TRANSFER: 'warehouse/get-list-transfer'
  },
  NOTIFY: {
    GET_LIST: 'notification/get-list'
  },
  PROMOTION: {
    GET_LIST: 'promotion/get-list',
    GET_DETAIL: 'promotion/get-detail',
    ADD: 'promotion/add',
    DELETE: 'promotion/delete',
    UPDATE: 'promotion/update',
    GET_ACTIVE: 'promotion/get-active'
  },
  EINVOICE: {
    ADD_CONNECT: 'einvoice/add-connect',
    UPDATE_CONNECT: 'einvoice/update-connect',
    GET_CONNECTS: 'einvoice/get-connects',
    GET_PROVIDERS: 'einvoice/get-providers',
    GET_FILE: 'einvoice/get-file',
    SIGN: 'einvoice/sign',
    ADD_INFO: 'einvoice/add-info',
    DELETE_INFO: 'einvoice/delete-info',
    UPDATE_INFO: 'einvoice/update-info',
    GET_INFOS: 'einvoice/get-infos',
    GET_INVOICES: 'einvoice/get-invoices',
    GET_TEMPLATES: 'einvoice/get-templates',
    SEARCH_TAX_CODE: 'einvoice/search-tax-code'
  },
  STATS: {
    GET_OVERVIEW: 'v2/stat/get-overview',
    GET_SALES_BY_PRODUCTS: 'v2/stat/get-sales-by-products',
    GET_SALES_BY_CUSTOMERS: 'v2/stat/get-sales-by-customers',
    GET_SALES_BY_STAFFS: 'v2/stat/get-sales-by-staffs',
    GET_ORDER_FEE: 'v2/stat/get-order-fee'
  }
};
